export default [
  {
    icon: 'icon icon-home',
    index: '/dashboard',
    title: '总  览'
  },
  {
    icon: 'icon el-icon-takeaway-box',
    index: '/shop',
    title: '界  面',
    subs: [
      {
        index: '/menu/list',
        title: '菜单管理',
      },
      {
        index: '/section/list',
        title: '版块列表',
      },
      {
        index: '/section/college/list',
        title: '院校专业',
      }
    ]
  },
  {
    icon: 'icon el-icon-message',
    index: '/news',
    title: '情 报',
    subs: [
      {
        index: '/article/list',
        title: '信息资讯',
      },
      {
        index: '/subscription/list',
        title: '消息订阅',
      },

    ]
  },
  {
    icon: 'icon icon-content',
    index: '/content',
    title: '内  容',
    subs: [

      {
        index: '/teacher/list',
        title: '老师管理',
      },
      {
        index: '/resource/paper',
        title: '试卷管理',
      },
      {
        index: '/examQuestions/list',
        title: '题目管理',
      },

      {
        index: '/consult/list',
        title: '参考书籍'
      },
      {
        icon: 'icon el-icon-notebook-1',
        index: '/select',
        title: '文章管理',
        subs: [
          {
            index: '/selecet/account',
            title: '账号管理',
          },
          {
            index: '/selecet/selectedtopic',
            title: '选题规划',
          },
          {
            index: '/selecet/original',
            title: '创作中心',
          },
          {
            index: '/selecet/release',
            title: '进度日程',
          }
        ]
      },
    ],
  },
  {
    icon: 'icon el-icon-goods',
    index: '/commodity',
    title: '商  品',
    subs: [
      {
        index: '/course/list',
        title: '我的课程',
      }, {
        index: '/material/list',
        title: '我的资料'
      }, {
        index: '/read/list',
        title: '我的专栏',
      },
      {
        index: '/exam/list',
        title: '我的题库',
      },
    ]
  },
  {
    icon: 'icon icon-order',
    index: '/order',
    title: '订  单',
    subs: [
      {
        index: '/order/list',
        title: '订单管理',
      },
      {
        index: '/order/booking',
        title: '学长预约',
      },
      {
        index: '/order/commodityChange',
        title: '商品兑换',
      }

    ]
  },
  {
    icon: 'icon el-icon-user',
    index: '/member',
    title: '用  户',
    subs: [
      {
        index: '/member/list',
        title: '用户管理',
      },
      {
        index: '/points/task/list',
        title: '积分任务',
      },
      /* 
                            {
                                index: "/member/charge",
                                title: "返佣费率",
                            }, */
    ]
  },
  {
    icon: 'icon el-icon-medal',
    index: '/senior',
    title: '学  长',
    subs: [
      {
        index: '/senior/apply',
        title: '学长申请',
      },
      {
        index: '/senior/list',
        title: '学长管理',
      },

      {
        index: '/senior/communicate',
        title: '学长沟通',
      },
      {
        index: "/senior/noteMange",
        title: "笔记管理",
      }, {
        index: "/senior/orderMange",
        title: "订单管理",
      },
      {
        index: "/senior/userMange",
        title: "用户管理",
      },
      {
        index: "/senior/noteComment",
        title: "笔记评论",
      },
      {
        index: "/senior/shareStatistics",
        title: "分享统计",
      },
      {
        index: "/senior/topicMangement",
        title: "专题管理",
      },
      {
        index: "/senior/problemsSuggestion",
        title: "问题与建议",
      },
      {
        index: "/senior/message",
        title: "学长看法",
      },
      {
        index: '/senior',
        title: '历史菜单',
        subs: [
          {
            index: '/senior/service',
            title: '学长服务',
          },
          {
            index: "/senior/experience",
            title: "学长经验",
          },
          {
            index: "/senior/comment",
            title: "学长评论",
          },

          {
            index: "/senior/order",
            title: "学长订单",
          },
          {
            index: "/senior/profit",
            title: "收益分成",
          },
          {
            index: '/dynamic/list',
            title: '动态资讯',
          }, {
            index: '/senior/task',
            title: '任务大厅',
          },


        ]
      },
    ]
  },
  {
    icon: 'icon el-icon-monitor',
    index: '/operation',
    title: '运  营',
    subs: [
      {
        index: '/member/notice',
        title: '消息推送',
      },
      {
        index: '/activity/list',
        title: '拼团管理',
      },
      {
        index: '/joint/list',
        title: '联报管理',
      },
      {
        index: '/packagepurchase/list',
        title: '组合购管理',
      },
      {
        index: '/coupon/list',
        title: '优惠券包',
      },
      {
        index: '/ad/list',
        title: '广告展示',
      },
      {
        index: '/page/list',
        title: '活动单页',
      },
      {
        index: '/college/menu/list',
        title: '专属菜单',
      },
      {
        index: '/service/list',
        title: '专属客服',
      },
      {
        index: "/group/list",
        title: "Q群管理",
      },
      {
        index: "/template/list",
        title: "模板管理",
      },
      {
        index: "/groupmessage/list",
        title: "群发任务",
      },
      {
        index: "/miniprogram/list",
        title: "小程序管理",
      },
      {
        index: "/promotionLink/list",
        title: "推广链接",
      },
    ]
  },
  {
    icon: 'icon el-icon-coin',
    index: '/distribution',
    title: '分 销',
    subs: [{
      index: '/distribution/examine',
      title: '人员审核',
    },
    {
      index: '/distribution/personnel',
      title: '推广人员',
    }, {
      index: '/distribution/product',
      title: '推广商品',
    }, {
      index: '/distribution/order',
      title: '推广订单',
    },
    /*     {
            index: "/member/withdraw",
            title: "提现审核",
        },  */
    {
      index: "/distribution/help",
      title: "帮助中心",
    }, {
      index: "/distribution/settings",
      title: "分销设置",
    }, {
      index: "/distribution/recommend",
      title: "推广学员",
    },
    ],
  },
  {
    icon: 'icon el-icon-s-cooperation',
    index: '/warrant',
    title: '机 构',
    subs: [{

      index: '/warrant/productMange',
      title: '推广商品',

    }, {

      index: '/warrant/orderMange',
      title: '订单管理',

    }, {

      index: '/warrant/writeoffMange',
      title: '核销管理',

    }]
  },
  {
    icon: 'icon el-icon-data-line',
    index: '/project',
    title: '项 目',
    subs: [
      {
        index: '/adjust',
        title: '调剂系统',
        subs: [
          {
            index: '/adjust/overview',
            title: '总览',
          },
          {
            index: '/adjust/report',
            title: '调剂报告',
          },
          {
            index: '/adjust/employeesupplement',
            title: '调剂信息',
          },
          {
            index: '/adjust/article',
            title: '调剂资讯',
          },
          {
            index: '/adjust/supplement',
            title: '信息审核',
          },
          {
            index: '/adjust/assist',
            title: '协助调剂',
          },
          {
            index: '/adjust/information',
            title: '信息更新',
          }, {
            index: '/adjust/recommend',
            title: '调剂推荐',
          },
          {
            index: '/adjust/helpCenter',
            title: '帮助中心',
          },
          {
            index: '/adjust/adjustApply',
            title: '信息审核',
          }, {
            index: '/adjust/institutionalUser',
            title: '机构用户'
          }
        ],
      },
      {
        index: '/rank',
        title: '排名系统',
        subs: [
          {
            index: '/rank/dataquery',
            title: '数据查询',
          },
          {
            index: '/rank/question',
            title: '成绩查询',
          },
        ],
      },
      {
        index: '/query',
        title: '信息查询',
        subs: [
          {
            index: '/query/parameter',
            title: '参数管理',
          },
          {
            index: '/query/collegebasic',
            title: '基础内容',
          }, {
            index: '/query/apply',
            title: '内容申请',
          },
        ],
      },
    ]
  },
  {
    icon: 'icon el-icon-school',
    index: '/university',
    title: '院  校',
    subs: [
      {
        index: '/college/list',
        title: '院校管理',
      },
      {
        index: '/major/list',
        title: '专业管理',
      },
      {
        index: '/subject/list',
        title: '科目管理',
      },
      {
        index: '/information/list',
        title: '报考信息',
      },
      {
        index: '/admission/list',
        title: '录取信息',
      }
    ]
  },

  {
    icon: 'icon el-icon-postcard',
    index: '/staff',
    title: '员  工',
    subs: [
      {
        index: '/admin/list',
        title: '员工管理',
      },
      {
        index: '/role/list',
        title: '角色管理',
      },
      {
        index: '/rule/list',
        title: '权限管理',
      },
      {
        index: '/dept/list',
        title: '部门管理',
      },
    ]
  },

  {
    icon: 'icon el-icon-setting',
    index: '/setting',
    title: '设  置',
    subs: [
      {
        index: '/ordermission',
        title: '订单进度',
      },
      {
        index: '/freight',
        title: '运费模板',
      },
      {
        index: '/product/config',
        title: '产品配置',
      },
      {
        index: '/resource/trash',
        title: '产品回收',
      },
      {
        index: '/agreement',
        title: '协议管理'
      },
      {
        index: '/client',
        title: '平台管理'
      },
      {
        index: '/configure',
        title: '系统配置'
      },
      {
        index: '/loginrecord',
        title: '登录日志'
      }, {
        index: '/feedback',
        title: '问题反馈'
      },
    ]
  },
]
